import React, {useState, useEffect} from "react";
import { useTranslation } from 'react-i18next';
import {useLocation} from "react-router-dom";
import {useHistory} from "react-router-dom";
import {Icon, Checkbox} from "@blueprintjs/core";

// Libs
import {primaryColor} from "../common/libs/theme-lib";

// Hooks
import {useAuth} from "../auth/auth";

// Components
import Button from "../common/components/button";
import PasswordInput from "../common/components/password-input";
import ServiceConditionsDialog from "./service-conditions-dialog";

const WelcomePage = () => {

    // get welcome password token from params
    const location = useLocation();

    // redirect to login
    const history = useHistory();
    const to = "/login";

    // token
    const token = location.pathname.split("/welcome/")[1];

    // get value of params
    function getQueryVariable(param) {
        const query = location.search.substring(1);
        const vars = query.split("&");
        for (let i = 0; i < vars.length; i++) {
            const pair = vars[i].split("=");
            if (pair[0] === param) {
                return pair[1];
            }
        }
        return false;
    }

    // client param
    const client = location.search ? getQueryVariable("client").split("%20").join(" ").split("%22").join('"') : false;

    // i18n
    const {t} = useTranslation("welcome");

    // State
    const [password, setPassword] = useState({value: "", isValid: false});
    const [verifyPassword, setVerifyPassword] = useState({value: "", isValid: false});
    const [privacy, setPrivacy] = useState(false);
    const [readPrivacy, setReadPrivacy] = useState(false);

    const [validInputs, setValidInputs] = useState({
        validLength: false,
        validLower: false,
        validUpper: false,
        validNumber: false,
        validSpecial: false
    });
    const [validForm, setValidForm] = useState(false);

    const [isOpen, setIsOpen] = useState(false);

    // Hooks
    const auth = useAuth();

    // form validation
    function validatePassword(password) {
        const validLength = password.length >= 6;
        const validLower = password.search(/[a-z]/) !== -1;
        const validUpper = password.search(/[A-Z]/) !== -1;
        const validNumber = password.search(/[0-9]/) !== -1;
        const validSpecial = password.search(/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/) !== -1;

        setValidInputs({validLength: validLength, validLower: validLower, validUpper: validUpper, validNumber: validNumber, validSpecial: validSpecial});

        const isValid = validLength && validUpper && validLower && validNumber && validSpecial;

        setPassword({value: password, isValid: isValid});
    }

    function valueVerifyPassword(value) {
        setVerifyPassword({value: value});
    }

    function validateForm() {
        password.isValid && (password.value === verifyPassword.value) && privacy && readPrivacy ?
            setValidForm(true) : setValidForm(false);
    }

    useEffect(() => {
        validateForm();
    }, [password, verifyPassword, privacy, readPrivacy]);

    return (
        <div style={{
            display: "block",
            margin: "auto"
        }}>
            <h2 style={{fontSize: "18px"}}>{t("title")}</h2>
            {client && (
                <div>
                    <p>{t("text1")}</p>
                    <span style={{
                        fontSize: "18px",
                        textAlign: "center",
                        width: "90%",
                        margin: "20px auto",
                        display: "block"
                    }}>{client}</span>
                </div>
            )}
            <p>{t("text2")}</p>
            <PasswordInput
                label={t("welcome.password")}
                style={loginItemStyle}
                value={password.value}
                setValue={validatePassword}
            />
            <PasswordInput
                label={t("welcome.verifyPassword")}
                style={loginItemStyle}
                value={verifyPassword.value}
                setValue={valueVerifyPassword}
            />
            <div style={{
                display: "flex",
                flexDirection: "column",
                marginTop: "15px"
            }}>
                <div style={{
                    display: "flex"
                }}>
                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        width: 20,
                        height: 20,
                        border: "1px solid black",
                        borderRadius: 25,
                        marginRight: 10
                    }}>
                        <Icon icon="high-priority" iconSize={12} style={{margin: "auto"}}/>
                    </div>
                    <span>{t("requirements.title")}</span>
                </div>
                <ul>
                    <li style={liStyle}>
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between"
                        }}>
                            <div>
                                {t("requirements.characters")}
                            </div>
                            <div>
                                {validInputs.validLength && (
                                    <Icon icon="tick" iconSize={16} />
                                )}
                            </div>
                        </div>
                    </li>
                    <li style={liStyle}>
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between"
                        }}>
                            <div>
                                {t("requirements.lower")}
                            </div>
                            <div>
                                {validInputs.validLower && (
                                    <Icon icon="tick" iconSize={16} />
                                )}
                            </div>
                        </div>
                    </li>
                    <li style={liStyle}>
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between"
                        }}>
                            <div>
                                {t("requirements.upper")}
                            </div>
                            <div>
                                {validInputs.validUpper && (
                                    <Icon icon="tick" iconSize={16} />
                                )}
                            </div>
                        </div>
                    </li>
                    <li style={liStyle}>
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between"
                        }}>
                            <div>
                                {t("requirements.number")}
                            </div>
                            <div>
                                {validInputs.validNumber && (
                                    <Icon icon="tick" iconSize={16} />
                                )}
                            </div>
                        </div>
                    </li>
                    <li style={liStyle}>
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between"
                        }}>
                            <div>
                                {t("requirements.special")}
                            </div>
                            <div>
                                {validInputs.validSpecial && (
                                    <Icon icon="tick" iconSize={16} />
                                )}
                            </div>
                        </div>
                    </li>
                </ul>
                <div style={{display: "flex"}}>
                    <div style={{
                        width: "18px",
                        height: "18px",
                        overflow: "hidden",
                        marginRight: "15px"
                    }}>
                        <Checkbox
                            checked={privacy}
                            onChange={() => setPrivacy(privacy => !privacy)}
                        />
                    </div>
                    <div>
                        <p>{t("terms.text1")} <a style={termStyle} onClick={() => setIsOpen(true)}>{t("terms.cond")}</a></p>
                    </div>
                </div>
                <div style={{display: "flex"}}>
                    <div style={{
                        width: "18px",
                        height: "18px",
                        overflow: "hidden",
                        marginRight: "15px"
                    }}>
                        <Checkbox
                            checked={readPrivacy}
                            onChange={() => setReadPrivacy(readPrivacy => !readPrivacy)}
                        />
                    </div>
                    <div>
                        <p>{t("read_privacy")}</p>
                    </div>
                </div>
                <div style={{
                    fontSize: 12,
                    maxHeight: 200,
                    overflow: "auto"
                }}>
                    <p><b>{t("privacyPolicy.title")}</b></p>
                    <p>{t("privacyPolicy.text")}</p>
                    <p><b>{t("privacyPolicy.title0")}</b> {t("privacyPolicy.text0")}</p>
                    <p><b>{t("privacyPolicy.title1")}</b> {t("privacyPolicy.text1")}</p>
                    <p><b>{t("privacyPolicy.title2")}</b> {t("privacyPolicy.text2")}</p>
                    <p>{t("privacyPolicy.text3")}</p>
                    <ul>
                        <li>
                            <p>{t("privacyPolicy.liText0")}</p>
                        </li>
                        <li>
                            <p>{t("privacyPolicy.liText1")} <b>{t("privacyPolicy.liEmail")}</b></p>
                        </li>
                    </ul>
                    <p><b>{t("privacyPolicy.title3")}</b> {t("privacyPolicy.text4")} <a style={{color: primaryColor, fontWeight: "bolder", textDecoration: "underline"}} href={"https://www.auxiliarconservera.es/politica-de-privacidad"} target={"_blank"}>{t("privacyPolicy.url")}</a></p>
                </div>
            </div>
            {!!auth && !!auth.welcomeError && (
                <div style={{
                    backgroundColor: "#ffdddd",
                    color: "#ff0000",
                    border: "1px solid #ff0000",
                    borderRadius: 3,
                    fontWeight: "bold",
                    marginTop: 15,
                    maxWidth: "80%",
                    padding: 8
                }}>
                    {auth.welcomeError}
                </div>
            )}
            <div style={{
                display: "flex",
                marginTop: "15px"
            }}>
                <Button
                    intent="cancel"
                    text={t("action.cancel")}
                    action={() => !!to && history.push(to)}
                    style={{
                        marginRight: "15px",
                    }}
                />
                <Button
                    intent="primary"
                    text={t("action.signin")}
                    disabled={validForm}
                    action={() => {
                        auth.welcomeUser(token, password.value, verifyPassword.value);
                    }}
                />
            </div>
            <ServiceConditionsDialog
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
            />
        </div>
    );
};

export default WelcomePage;

const loginItemStyle = {
    marginTop: 15,
    display: "flex",
    flexDirection: "column",
    width: "200px"
}

const termStyle = {
    color: "black",
    fontWeight: 600,
    textDecoration: "underline"
}

const liStyle = {
    marginTop: "5px",
    width: "200px"
}